function resolveCrypto(): Crypto {
  if (typeof globalThis !== 'undefined' && 'crypto' in globalThis && globalThis.crypto) {
    return globalThis.crypto as Crypto;
  }
  throw new Error('Secure crypto unavailable in this environment');
}

export function getSubtleCrypto(): SubtleCrypto {
  const resolved = resolveCrypto();
  if (!resolved.subtle) {
    throw new Error('SubtleCrypto unsupported');
  }
  return resolved.subtle;
}
